export default __webpack_public_path__ + "static/media/lhs.a0461821.png";